import React from 'react'
import {
  List,
  Filter,
  Datagrid,
  TextField,
  BooleanField,
  SearchInput,
  usePermissions,
} from 'react-admin'
import ListPagination from '../../components/ListPagination'
import Permission from '../../components/Permission'
import { PERMISSIONS } from '../../constants'

const UserFilter = ({ ...props }) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
  </Filter>
)

export default ({ ...props }) => {

  const { permissions } = usePermissions();

  return (
    <Permission permission={PERMISSIONS.CREATE_PROFILE}>
      <List
        {...props}
        perPage={25}
        pagination={<ListPagination />}
        exporter={false}
        title="Perfis"
        filters={<UserFilter {...props} />}
      >
        <Datagrid
          rowClick={(permissions && permissions.includes(PERMISSIONS.UPDATE_PROFILE)) && 'edit'}
          bulkActionButtons={permissions && permissions.includes(PERMISSIONS.UPDATE_PROFILE)}
        >
          <TextField source="name" label="Nome" />
          <BooleanField source="fullAccess" label="Acesso total" />
        </Datagrid>
      </List>
    </Permission >
  );
}
